import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
  export class UnitsService {

  constructor(private http : HttpClient) { }

  async getDrivers(date, unitId) {
    return this.http.get(
      environment.apiUrl +
        '/activities/' +
        unitId +
        '/' +
        'date' +
        '/' +
        date +
        '/' +
        'drivers'
    );
  }

  getAllUnits(e){
      return this.http.get(environment.apiUrl +'/companies/'+e+'/units/all');
  }

  }
